// extracted by mini-css-extract-plugin
module.exports = {"numberOfFilesLink":"YYEiL","hasFiles":"zyIZw","placeholder":"_-8MMN"};